import axios from "axios";
import { getToken } from "./getToken";
import { message } from "antd";

const baseURL =
  window.location.hostname === "admin.bettydistribution.com"
    ? process.env.REACT_APP_BASE_URL_PROD
    : process.env.REACT_APP_BASE_URL;

export const axiosInstance = axios.create({
  baseURL: baseURL,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      const tokenParsed = getToken();

      if (tokenParsed && typeof tokenParsed === "string" && config.headers) {
        config.headers.authorization = `Bearer ${tokenParsed}`;
      }
    } catch (error) {
      console.error("Error parsing token:", error);
    }
    return config;
  },
  async (error) => {
    message.error("Request error: " + error.message);
    console.log("==> REFRESHHH <==", error);
    return Promise.reject(error);
  }
);
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      message.info(`Response code: ${error.response.status}`);
      if (error.response.status === 401) {
        localStorage.clear();
        message.info("Session expired. Redirecting to login.");
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);
